export const messages = {
  en: {
    marketSms: {
      search: {
        title: 'Search Conditions',
        smsName: 'Please enter name',
        smsType: 'Please select type'
      },
      list: {
        title: 'Marketing Configuration'
      },
      table: {
        smsId: 'ID',
        smsName: 'Name',
        smsType: 'Type',
        createTime: 'Create Time',
        remark: 'Remark'
      },
      form: {
        smsName: 'Name',
        smsType: 'Type',
        remark: 'Remark'
      },
      placeholder: {
        smsName: 'Please enter name',
        smsType: 'Please select type',
        remark: 'Please enter remark'
      },
      validate: {
        smsName: 'Name is required',
        smsNameMax: 'Name cannot exceed 64 characters',
        smsType: 'Type is required',
        remark: 'Remark is required',
        remarkMax: 'Remark cannot exceed 512 characters',
        smsId: 'ID is required'
      },
      add: {
        title: 'Add Marketing SMS',
        success: 'Add successful'
      },
      edit: {
        title: 'Edit Marketing SMS',
        success: 'Edit successful'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this marketing SMS?',
        success: 'Delete successful'
      },
      fetchError: 'Failed to fetch data'
    }
  },
  zh: {
    marketSms: {
      search: {
        title: '查询条件',
        smsName: '请输入名称',
        smsType: '请选择类型'
      },
      list: {
        title: '营销配置'
      },
      table: {
        smsId: '编号',
        smsName: '名称',
        smsType: '设置类型',
        createTime: '创建时间',
        remark: '备注'
      },
      form: {
        smsName: '名称',
        smsType: '设置类型',
        remark: '备注'
      },
      placeholder: {
        smsName: '请输入名称',
        smsType: '请选择设置类型',
        remark: '请输入备注'
      },
      validate: {
        smsName: '名称不能为空',
        smsNameMax: '名称不能超过64个字符',
        smsType: '设置类型不能为空',
        remark: '备注不能为空',
        remarkMax: '备注不能超过512个字符',
        smsId: '编号不能为空'
      },
      add: {
        title: '添加营销短信',
        success: '添加成功'
      },
      edit: {
        title: '修改营销短信',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除该营销短信吗？',
        success: '删除成功'
      },
fetchError: '获取数据失败'
    }
  },
  'zh-TW': {
    marketSms: {
      search: {
        title: '查詢條件',
        smsName: '請輸入名稱',
        smsType: '請選擇類型'
      },
      list: {
        title: '營銷配置'
      },
      table: {
        smsId: '編號',
        smsName: '名稱',
        smsType: '設置類型',
        createTime: '創建時間',
        remark: '備註'
      },
      form: {
        smsName: '名稱',
        smsType: '設置類型',
        remark: '備註'
      },
      placeholder: {
        smsName: '請輸入名稱',
        smsType: '請選擇設置類型',
        remark: '請輸入備註'
      },
      validate: {
        smsName: '名稱不能為空',
        smsNameMax: '名稱不能超過64個字符',
        smsType: '設置類型不能為空',
        remark: '備註不能為空',
        remarkMax: '備註不能超過512個字符',
        smsId: '編號不能為空'
      },
      add: {
        title: '新增營銷短信',
        success: '新增成功'
      },
      edit: {
        title: '修改營銷短信',
        success: '修改成功'
      },
      delete: {
        title: '刪除確認',
        confirm: '確定刪除該營銷短信嗎？',
        success: '刪除成功'
      },
      fetchError: '獲取數據失敗'
    }
  }
}